__turbopack_context__.v({
  "dropdown-wrapper": "Dropdown-module-scss-module__nX11-a__dropdown-wrapper",
  "dropdownArrow": "Dropdown-module-scss-module__nX11-a__dropdownArrow",
  "dropdownContainer": "Dropdown-module-scss-module__nX11-a__dropdownContainer",
  "dropdownHeader": "Dropdown-module-scss-module__nX11-a__dropdownHeader",
  "dropdownImage": "Dropdown-module-scss-module__nX11-a__dropdownImage",
  "dropdownItem": "Dropdown-module-scss-module__nX11-a__dropdownItem",
  "dropdownLabel": "Dropdown-module-scss-module__nX11-a__dropdownLabel",
  "dropdownList": "Dropdown-module-scss-module__nX11-a__dropdownList",
  "selectedDropdownLabel": "Dropdown-module-scss-module__nX11-a__selectedDropdownLabel",
});
